import { login, logout, getInfo, authCheck } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getBrand, getType, getLevel } from '@/api/car'
import watermark from '@/utils/warterMark'
import router, { resetRouter } from '@/router'
import md5 from 'js-md5'
const state = {
	token: getToken(),
	name: '',
	iscompany: '',
	info: '',
	avatar: '',
	introduction: '',
	roles: [],
	roles_name: [],
	menu: [],
	nav: [],
	loading: false,
	share_menu_buttons: {} // 公共资源按钮权限
}

const mutations = {
	SET_LOADING: (state, token) => {
		state.loading = token
	},
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_INTRODUCTION: (state, introduction) => {
		state.introduction = introduction
	},
	SET_NAME: (state, name) => {
		state.name = name
	},
	SET_USER_ID: (state, userId) => {
		state.userId = userId
	},
	SET_ISCOMPANY: (state, iscompany) => {
		state.iscompany = iscompany
	},
	SET_INFO: (state, info) => {
		state.info = info
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_NAV: (state, nav) => {
		state.nav = nav
	},
	SET_MENUS: (state, menu) => {
		state.menu = menu
	},
	SET_ROLE_NAME: (state, name) => {
		state.roles_name = name
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	},
	SET_ORG_CODE: (state, roles) => {
		state.org_code = roles
	},
	SET_SHARE_MENU: (state, buttons) => {
		state.share_menu_buttons = buttons
	}
}

const actions = {
	// 找回密码用户验证
	authCheck({ commit }, info) {
		const { username, phonecode } = info
		return new Promise((resolve, reject) => {
			authCheck({ account: username.trim(), is_encrypt: 0, sms_code: phonecode, origin: 'company' })
				.then(response => {
					const { data } = response
					commit('SET_TOKEN', data.token)
					setToken(data.token)
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	// user login
	login({ commit }, userInfo) {
		const { username, password, phonecode, imgcode, captcha_id } = userInfo
		return new Promise((resolve, reject) => {
			const params = {
				account: username.trim(),
				password: md5(password),
				is_encrypt: 1,
				sms_code: phonecode,
				origin: 'company',
				captcha_value: imgcode,
				captcha_id
			}
			login(params)
				.then(response => {
					const { data } = response
					commit('SET_TOKEN', data.token)
					commit('SET_ORG_CODE', data?.isHeadquarter ? data?.isHeadquarter : false)
					setToken(data.token)
					resolve(response)
					// if(!data?.isHeadquarter && process.env.NODE_ENV == "production"){
					//   window.location="http://vendor-dcms.jryghq.com"
					// }
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// get user info
	getInfo({ commit, state }) {
		// 菜单迁移，根据规则匹配路由标识，去除_new
		function removeNewFromName(menu) {
			menu.forEach(item => {
				if (item.name && item.name.includes('_new')) {
					item.path = item.path + '_new'
					item.name = item.name.replace('_new', '')
				}
				if (item.children && item.children.length > 0) {
					removeNewFromName(item.children)
				}
			})
		}
		return new Promise((resolve, reject) => {
			getInfo()
				.then(response => {
					if (response?.code === 10000) {
						const { data } = response
						const { menu = [], info, root_menu, buttons = {} } = data
						removeNewFromName(menu)
						commit('SET_MENUS', menu)
						commit('SET_NAV', root_menu)
						commit('SET_ROLES', ['admin'])
						commit('SET_ROLE_NAME', info.roles_name || [])
						commit('SET_NAME', info.account)
						watermark.set('阳光出行' + ' ' + info.name + '-' + info.uid)
						commit('SET_USER_ID', info.uid)
						commit('SET_ISCOMPANY', info.is_headquarter)
						commit('SET_INFO', info)
						commit('SET_SHARE_MENU', buttons)
						window.__bl?.setConfig({ uid: info.uid })
						window.__bl?.setConfig({
							setUsername: function () {
								return info.name
							}
						})
						getBrand().then(res => {
							// car_brand_base 表
							localStorage.setItem('carBrand', JSON.stringify(res.data))
						})
						getLevel().then(res => {
							// cartype 表信息
							localStorage.setItem('carLevel', JSON.stringify(res.data))
						})
						resolve(response)
					}
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// user logout
	logout({ state, dispatch }, payload = {}) {
		const { isStatic = false } = payload
		return new Promise((resolve, reject) => {
			if (isStatic) {
				dispatch('logoutCallback')
				resolve()
			} else {
				logout(state.token)
					.then(() => {
						dispatch('logoutCallback')
						resolve()
					})
					.catch(error => {
						reject(error)
					})
			}
		})
	},
	logoutCallback({ commit, dispatch }) {
		commit('SET_TOKEN', '')
		commit('SET_MENUS', [])
		commit('SET_ROLES', [])
		commit('SET_SHARE_MENU', {})
		dispatch('permission/clearRoutes', [], { root: true })
		removeToken()
		resetRouter()
		localStorage.clear()
		// reset visited views and cached views
		// to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
		dispatch('tagsView/delAllViews', null, { root: true })
	},
	// remove token
	resetToken({ commit }) {
		return new Promise(resolve => {
			commit('SET_TOKEN', '')
			commit('SET_ROLES', [])
			watermark.set('')
			removeToken()
			resolve()
		})
	},
	// set loading
	setLoading({ commit }, data) {
		return new Promise(resolve => {
			// console.log(data)
			commit('SET_LOADING', data)

			resolve()
		})
	},
	// dynamically modify permissions
	changeRoles({ commit, dispatch }, role) {
		console.log('change role')
		return new Promise(async resolve => {
			const token = role + '-token'
			commit('SET_TOKEN', token)
			setToken(token)
			const { roles } = await dispatch('getInfo')
			resetRouter()
			// generate accessible routes map based on roles
			const accessRoutes = await dispatch(
				'permission/generateRoutes',
				{ menu: roles },
				{ root: true }
			)
			// dynamically add accessible routes
			router.addRoutes(accessRoutes)
			// reset visited views and cached views
			dispatch('tagsView/delAllViews', null, { root: true })
			resolve()
		})
	}
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
}
